import React, { ReactNode } from 'react';
import { Header } from './Header';
import { Footer } from './Footer';
type SiteLayoutProps = {
  children: ReactNode;
};
export function SiteLayout({
  children
}: SiteLayoutProps) {
  return <div className="min-h-screen bg-white font-sans text-brand-charcoal" data-id="element-685" data-mp="34v4t3z1l0tjy">
      <Header data-id="element-686" data-mp="39u7pkv3hxrgb" />
      {children}
      <Footer data-id="element-687" data-mp="39viqmn5k4l3q" />
    </div>;
}